import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useSoftwareUpdatePolicies } from "@/hooks/useSoftwareUpdates";
import { Skeleton } from "@/components/ui/skeleton";

export function TopPolicies() {
  const { policies, isLoading } = useSoftwareUpdatePolicies();

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          Software update policies
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-2">
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="h-8 w-full" />
            ))}
          </div>
        ) : policies.length === 0 ? (
          <p className="text-xs text-muted-foreground">
            No software update policies yet. Create one from Configurations.
          </p>
        ) : (
          <ul className="divide-y">
            {policies.slice(0, 5).map((p) => (
              <li key={p.id} className="flex items-center justify-between py-2 text-sm">
                <span className="truncate font-medium">{p.name}</span>
                <Badge variant="outline" className="ml-2 shrink-0">
                  {p.payloads?.length ?? 0} payload{(p.payloads?.length ?? 0) === 1 ? "" : "s"}
                </Badge>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}

export default TopPolicies;
